import { LauncherElement } from '../../types/launcherElement';
import { BoxElement } from './BoxElement';
import { ButtonElement } from './ButtonElement';
import { IFrameElement } from './IFrameElement';
import { ImgElement } from './ImgElement';
import { LinkElement } from './LinkElement';
import { ProgressbarElement } from './ProgresbarElement';
import { TextElement } from './TextElement';
import { VariableTextElement } from './VariableTextElement';

export const Element = ({ element }: { element: LauncherElement }) => {
  const chooseElement = (element: LauncherElement) => {
    switch (element?.type) {
      case 'div':
        return (
          <BoxElement key={element.id} elementID={element.id}>
            {element.props?.children?.map((child) => (
              <Element key={child.id} element={child} />
            ))}
          </BoxElement>
        );
      case 'button':
        return (
          <ButtonElement key={element.id} elementID={element.id}>
            {element.props?.children?.map((child) => (
              <Element key={child.id} element={child} />
            ))}
          </ButtonElement>
        );
      case 'text':
        return <TextElement key={element.id} elementID={element.id} />;
      case 'variableText':
        return <VariableTextElement key={element.id} elementID={element.id} />;
      case 'link':
        return <LinkElement key={element.id} elementID={element.id} />;
      case 'img':
        return <ImgElement key={element.id} elementID={element.id} />;
      case 'iframe':
        return <IFrameElement key={element.id} elementID={element.id} />;
      case 'appTaskProgressBar':
        return <ProgressbarElement key={element.id} elementID={element.id} />;

      default:
        return <></>;
    }
  };

  return chooseElement(element);
};
